import pdfMake from 'pdfmake/build/pdfmake'
import { MagnifyingGlass } from 'phosphor-react'
import { useEffect, useState } from 'react'
import {
  Alert,
  Card,
  Col,
  Container,
  Form,
  OverlayTrigger,
  Row,
  Spinner,
  Table,
  Tooltip,
} from 'react-bootstrap'
import { Check2Square } from 'react-bootstrap-icons'
import { BsDownload } from 'react-icons/bs'
import { CustomButton } from '../../../components/CustomButton/index.jsx'
import Navbar from '../../../components/navbar/navbar.jsx'
import { useOrdenation } from '../../../hooks/useOrdenation/index.js'
import apinode from '../../../services/apinode'

//pdfMake.addVirtualFileSystem(pdfFonts);

const ComprasRelatorios = () => {
  const [produtos, setProdutos] = useState([])
  const [familias, setFamilias] = useState([])
  const [loading, setLoading] = useState(false)
  const [erro, setErro] = useState(null)
  const [busca, setBusca] = useState('')
  const [dias, setDias] = useState(90)
  const [diasDesejadosEstoque, setDiasDesejadosEstoque] = useState(20)
  const [diasFuturos, setDiasFuturos] = useState(60)
  const [familia, setFamilia] = useState('')
  const [tipoBusca, setTipoBusca] = useState('sku')
  const [selecionados, setSelecionados] = useState([])

  const buscarProdutos = async () => {
    setLoading(true)
    setErro(null)
    try {
      const params = tipoBusca === 'sku' ? { sku: busca } : { descricao: busca }
      if (familia) params.marca = familia
      if (dias) params.dias = dias
      const response = await apinode.get(
        `relatorio/compras/${localStorage.idconta}`,
        { params },
      )
      const produtosData = response.data
      setProdutos(produtosData)

      // Define seleção inicial
      produtosData.forEach((produto) => {
        const media = produto.media_venda_diaria || 0
        const estoque = produto.estoque_total || 0
        const lead = produto.maior_lead_time || 0
        const coberturaEstoque = media > 0 ? estoque / media : 0
        // const estoqueFuturo = estoque - media * diasDesejadosEstoque
        const ddeAtual = coberturaEstoque - lead
        const coberturaFutura = ddeAtual - diasFuturos
        const sugestao =
          media > 0
            ? Math.max(
              0,
              Math.ceil((diasDesejadosEstoque - coberturaFutura) * media),
            )
            : 0

        if (sugestao > 0) {
          setSelecionados((prevState) => [...prevState, produto])
        }
      })
    } catch (error) {
      console.log(error)
      setErro('Erro ao buscar dados da API.')
    } finally {
      setLoading(false)
    }
  }

  const { filteredItems, Th, Paginate, itemsPerPage, setItemsPerPage } =
    useOrdenation(produtos, 'descricao', 'asc', '50')

  const gerarPDF = () => {
    const tableColumn = [
      'SKU Pai',
      'SKU',
      'Desc.',
      'Cus. Prod.',
      'Cus. Méd.',
      'Est.',
      'Est. full',
      `Vend. (${dias}d)`,
      'Qtd Env. Full',
      'Média',
      'Lead',
      'Cob.',
      `Est. Futuro (${diasFuturos}d)`,
      'Sug.',
    ]

    const marcaInfo = familia
      ? `Marca: ${familias.find((f) => String(f.id) === String(familia))?.nome || 'Não encontrada'}`
      : 'Marca: Todas'

    const configInfo = `Dias de Vendas: ${dias} | Dias: ${diasDesejadosEstoque} | Cobertura: ${diasFuturos}`

    const agora = new Date()
    const dataHora = `Data/Hora da impressão: ${agora.toLocaleDateString()} ${agora.toLocaleTimeString()}`

    const tableRows = selecionados.map((produto) => {
      const media = produto.media_venda_diaria || 0
      const custo_sku_pai = Number(produto?.custo_sku_pai) || 0
      const custo_medio = Number(produto?.custo_medio).toFixed(2) || 0
      const estoque = produto.estoque_total || 0
      const lead = produto.maior_lead_time || 0
      const coberturaEstoque = media > 0 ? estoque / media : 0
      const estoqueFuturo = estoque - media * diasDesejadosEstoque
      const ddeAtual = coberturaEstoque - lead
      const coberturaFutura = ddeAtual - diasFuturos
      const sugestao =
        media > 0
          ? Math.max(
            0,
            Math.ceil((diasDesejadosEstoque - coberturaFutura) * media),
          )
          : '—'

      return [
        { text: produto.sku_pai, fontSize: 7 },
        { text: produto.sku, fontSize: 7 },
        {
          text:
            produto.descricao?.length > 120
              ? produto.descricao.substring(0, 117) + '...'
              : produto.descricao,
          fontSize: 7,
        },
        { text: custo_sku_pai, fontSize: 7 },
        { text: custo_medio, fontSize: 7 },
        { text: estoque, fontSize: 7 },
        { text: produto.estq_full, fontSize: 7 },
        { text: produto.qtde_vendida_90_dias, fontSize: 7 },
        { text: produto.qtde_full_90_dias, fontSize: 7 },
        { text: media.toFixed(1), fontSize: 7 },
        { text: lead, fontSize: 7 },
        {
          text: coberturaEstoque > 0 ? coberturaEstoque.toFixed(1) : '—',
          fontSize: 7,
        },
        { text: estoqueFuturo.toFixed(0), fontSize: 7 },
        { text: sugestao, fontSize: 7 },
      ]
    })

    const docDefinition = {
      pageOrientation: 'landscape',
      pageSize: 'A4',
      content: [
        { text: 'Relatório de Compras', style: 'header' },
        { text: dataHora, style: 'subHeader' },
        { text: marcaInfo, style: 'subHeader' },
        { text: configInfo, style: 'subHeader' },
        {
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: [20, 20, 300, '*', '*', 20, 20, 20, 20, 20, 20, 25, 25, 25],
            body: [
              tableColumn.map((col) => ({
                text: col,
                fontSize: 8,
                bold: true,
              })),
              ...tableRows,
            ],
          },
          layout: 'lightHorizontalLines',
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          alignment: 'center',
          margin: [0, 0, 0, 10],
        },
        subHeader: {
          fontSize: 10,
          italics: true,
          margin: [0, 2, 0, 5],
          alignment: 'center',
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
      },
      pageMargins: [30, 10, 30, 10],
    }

    pdfMake.createPdf(docDefinition).open()
  }

  function selectAllProducts(products) {
    for (const product of products) {
      setSelecionados((prevState) => {
        const index = prevState.findIndex((prod) => prod.sku == product.sku)

        if (index === -1) {
          return [...prevState, product]
        }

        return prevState
      })
    }
  }

  useEffect(() => {
    const buscarFamilias = async () => {
      try {
        const response = await apinode.get(
          `/estoque/marca/${localStorage.idconta}`,
        )
        const familiasFormatadas = response.data.map((f) => ({
          id: f.ID_MARCA,
          nome: f.DESC_MARCA,
        }))
        setFamilias([{ id: '', nome: 'Todas' }, ...familiasFormatadas])
      } catch (error) {
        console.error('Erro ao carregar famílias:', error)
        setErro('Não foi possível carregar as famílias.')
      }
    }

    buscarFamilias()
  }, [])

  return (
    <>
      <Navbar />
      <Container className="mt-page">
        <Card>
          <Card.Header as="h5">Estoque e Vendas — Produtos</Card.Header>
          <Card.Body>
            {/* Formulário de filtros */}
            <Form className="mb-4">
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>SKU ou Descrição</Form.Label>
                    <Form.Control
                      type="text"
                      value={busca}
                      onChange={(e) => setBusca(e.target.value)}
                      placeholder="Digite o SKU ou nome do produto"
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Qtd dias vendas</Form.Label>
                    <Form.Control
                      type="number"
                      value={dias}
                      onChange={(e) => setDias(Number(e.target.value))}
                      placeholder="Ex: 90"
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Dias</Form.Label>
                    <Form.Control
                      type="number"
                      value={diasDesejadosEstoque}
                      onChange={(e) =>
                        setDiasDesejadosEstoque(Number(e.target.value))
                      }
                      placeholder="Ex: 60"
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Cobertura</Form.Label>
                    <Form.Control
                      type="number"
                      value={diasFuturos}
                      onChange={(e) => setDiasFuturos(Number(e.target.value))}
                      placeholder="Ex: 30"
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Família de produtos</Form.Label>
                    <Form.Select
                      value={familia}
                      onChange={(e) => setFamilia(e.target.value)}
                    >
                      {familias.map((item) => (
                        <option
                          key={item.id}
                          value={item.id}
                        >
                          {item.nome}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs={10}>
                  <Form.Label
                    column
                    sm={3}
                  >
                    Tipo de busca
                  </Form.Label>

                  <Form.Check
                    inline
                    label="SKU"
                    type="radio"
                    id="sku"
                    name="tipoBusca"
                    value="sku"
                    checked={tipoBusca === 'sku'}
                    onChange={() => setTipoBusca('sku')}
                  />

                  <Form.Check
                    inline
                    label="Descrição"
                    type="radio"
                    id="descricao"
                    name="tipoBusca"
                    value="descricao"
                    checked={tipoBusca === 'descricao'}
                    onChange={() => setTipoBusca('descricao')}
                  />
                </Col>

                <Col xs={2}>
                  <Form.Group>
                    <Form.Label>Produtos p/ página</Form.Label>
                    <Form.Select
                      value={itemsPerPage}
                      onChange={(e) => setItemsPerPage(e.target.value)}
                    >
                      <option
                        key={'10'}
                        value={'10'}
                      >
                        10
                      </option>

                      <option
                        key={'20'}
                        value={'20'}
                      >
                        20
                      </option>

                      <option
                        key={'50'}
                        value={'50'}
                      >
                        50
                      </option>

                      <option
                        key={'100'}
                        value={'100'}
                      >
                        100
                      </option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      gap: 5,
                    }}
                  >
                    <CustomButton
                      noMargin
                      title="Buscar"
                      onClick={buscarProdutos}
                      isLoading={loading}
                    >
                      <MagnifyingGlass />
                    </CustomButton>

                    <CustomButton
                      noMargin
                      isSuccess
                      title="Baixar PDF"
                      onClick={gerarPDF}
                      isDisabled={selecionados.length === 0}
                    >
                      <BsDownload />
                    </CustomButton>
                  </div>
                </Col>
              </Row>
            </Form>

            {loading ? (
              <div className="text-center">
                <Spinner
                  animation="border"
                  variant="primary"
                />
                <p className="mt-3">Carregando dados do relatório...</p>
              </div>
            ) : erro ? (
              <Alert variant="danger">{erro}</Alert>
            ) : produtos.length > 0 ? (
              <>
                <Table
                  striped
                  bordered
                  hover
                  responsive
                  className="small"
                >
                  <thead>
                    <tr>
                      <th colSpan="11">
                        <div
                          style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: 10,
                            }}
                          >
                            <CustomButton
                              noMargin
                              title="Selecionar/Desmarcar Todos"
                              onClick={() => {
                                if (selecionados.length !== produtos.length) {
                                  selectAllProducts(produtos)
                                } else {
                                  setSelecionados([])
                                }
                              }}
                            >
                              <Check2Square />
                            </CustomButton>

                            <p style={{ margin: 0 }}>
                              {selecionados.length} selecionados
                            </p>
                          </div>

                          <p style={{ margin: 0 }}>
                            {' '}
                            Mostrando {filteredItems.length} de{' '}
                            {produtos.length}{' '}
                          </p>
                        </div>
                      </th>
                    </tr>

                    <tr>
                      <th>
                        <Form.Check
                          type="checkbox"
                          checked={
                            filteredItems.length > 0 &&
                            filteredItems.every(
                              (produto) =>
                                selecionados.findIndex(
                                  (prod) => prod.sku == produto.sku,
                                ) > -1,
                            )
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              selectAllProducts(filteredItems)
                            } else {
                              for (const produto of filteredItems) {
                                setSelecionados((prevState) =>
                                  prevState.filter(
                                    (prod) => prod.sku !== produto.sku,
                                  ),
                                )
                              }
                            }
                          }}
                        />
                      </th>

                      <Th
                        label="SKU Pai"
                        value="sku_pai"
                      />

                      <Th
                        label="SKU"
                        value="sku"
                      />

                      <Th
                        label="Descrição"
                        value="descricao"
                      />

                      <Th
                        label="Cus. Prod."
                        value="custo_sku_pai"
                      />

                      <Th
                        label="Cus. Méd."
                        value="custo_medio"
                      />

                      <Th
                        label="Est."
                        value="estoque_total"
                      />
                      <Th
                        label="Est. full"
                        value="estq_full"
                      />

                      <Th
                        label={`Vend. (${dias}d)`}
                        value="qtde_vendida_90_dias"
                      />

                      <Th
                        label="Qtd Envio Full"
                        value="qtde_full_90_dias"
                      />

                      <Th
                        label="Média"
                        value="media_venda_diaria"
                      />

                      <Th
                        label="Lead"
                        value="maior_lead_time"
                      />

                      <th>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              Cobertura de Estoque = Estoque / Média
                            </Tooltip>
                          }
                        >
                          <span>Cobertura</span>
                        </OverlayTrigger>
                      </th>

                      <th>Estq Futuro ({diasFuturos}d)</th>

                      <th>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              Nova sugestão baseada em cobertura ideal
                            </Tooltip>
                          }
                        >
                          <span>Sugestão</span>
                        </OverlayTrigger>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredItems.map((produto, index) => {
                      const media = produto.media_venda_diaria || 0
                      const estoque = produto.estoque_total || 0
                      const lead = produto.maior_lead_time || 0
                      const coberturaEstoque = media > 0 ? estoque / media : 0
                      const estoqueFuturo =
                        estoque - media * diasDesejadosEstoque
                      const ddeAtual = coberturaEstoque - lead
                      const coberturaFutura = ddeAtual - diasFuturos
                      const sugestao =
                        media > 0
                          ? Math.max(
                            0,
                            Math.ceil(
                              (diasDesejadosEstoque - coberturaFutura) *
                              media,
                            ),
                          )
                          : '—'
                      return (
                        <tr key={index}>
                          <td>
                            <Form.Check
                              type="checkbox"
                              checked={
                                selecionados.findIndex(
                                  (prod) => prod.sku == produto.sku,
                                ) === -1
                                  ? false
                                  : true
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelecionados((prevState) => [
                                    ...prevState,
                                    produto,
                                  ])
                                } else {
                                  setSelecionados((prevState) =>
                                    prevState.filter(
                                      (prod) => prod.sku !== produto.sku,
                                    ),
                                  )
                                }
                              }}
                            />
                          </td>
                          <td>{produto.sku_pai}</td>
                          <td>{produto.sku}</td>
                          <td>{produto.descricao}</td>
                          <td>{Number(produto?.custo_sku_pai).toFixed(2)}</td>
                          <td>{Number(produto?.custo_medio).toFixed(2)}</td>
                          <td>{estoque}</td>
                          <td>{produto?.estq_full}</td>
                          <td>{produto.qtde_vendida_90_dias}</td>
                          <td>{produto.qtde_full_90_dias}</td>
                          <td>{media.toFixed(1)}</td>
                          <td>{lead}</td>
                          <td>
                            {coberturaEstoque > 0
                              ? coberturaEstoque.toFixed(1)
                              : '—'}
                          </td>
                          <td>{estoqueFuturo.toFixed(0)}</td>
                          <td>{sugestao}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>

                <Paginate />
              </>
            ) : null}
          </Card.Body>
        </Card>
      </Container>
    </>
  )
}

export default ComprasRelatorios
